import React, { useEffect, useState } from 'react'
import { Btn, CustomModal, InputText } from '../../../../components'

function ModalCancelarNfse({ nfse, isVisible, onCancel, onSave, onError }) {
  // Hooks
  const [justificativa, setJustificativa] = useState('')

  useEffect(() => {
    if (isVisible) setJustificativa('')
  }, [isVisible])

  if (!nfse) return null

  // Events
  const onBtnSalvarClicked = () => {
    const justificativaLimpa = justificativa.trim()
    if (justificativaLimpa.length < 15) {
      onError('A justificativa deve conter pelo menos 15 caracteres')
      return
    }
    if (justificativaLimpa.length > 255) {
      onError('A justificativa deve conter no máximo 255 caracteres')
      return
    }
    onSave(nfse, justificativaLimpa)
  }

  // Render
  return (
    <CustomModal
      header={`Cancelar NFS-e nº ${nfse.numero}`}
      isVisible={isVisible}
      onClose={onCancel}
    >
      <form className="p-grid">
        <div className="p-col-12">
          <span style={{ color: 'gray', fontSize: 12 }}>
            O prazo para cancelar a NFS-e depende da prefeitura. Fora dele, o cancelamento é
            recusado e precisa ser pedido à prefeitura.
          </span>
        </div>
        <div className="p-col-12">
          <InputText
            label="Justificativa (entre 15 e 255 caracteres):"
            marginTop={10}
            value={justificativa}
            maxLength={255}
            onChange={value => setJustificativa(value)}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClicked}>Cancelar NFS-e</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default ModalCancelarNfse
